<ihd-dialog-title>{{ config?.title | translate }}</ihd-dialog-title>
<ihd-dialog-body>
    <span
        [innerHTML]="config?.content | translate: config?.contentParams"
    ></span>
</ihd-dialog-body>
<ihd-dialog-actions class="justify-content-center">
    <button
        ihdButton
        type="button"
        class="c-btn--primary c-btn--lg c-btn--wlg"
        [disabled]="isBusy"
        (click)="process()"
    >
        {{ config?.btnText || 'Common.Ok' | translate }}
    </button>
</ihd-dialog-actions>
